import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "../lib/api";
import { useAuth } from "../context/AuthContext";
import { BagLogoTile } from "./Logo";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const processed = useRef(false);
  const [error, setError] = useState(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const hash = window.location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    const sessionId = match ? match[1] : null;
    const dest = sessionStorage.getItem("ponesi_return_to") || "/";
    sessionStorage.removeItem("ponesi_return_to");

    if (!sessionId) { navigate("/", { replace: true }); return; }

    (async () => {
      try {
        const { data } = await api.post("/auth/session", { session_id: sessionId });
        setUser(data.user);
        window.history.replaceState(null, "", window.location.pathname);
        navigate(dest, { replace: true, state: { user: data.user } });
      } catch (e) {
        setError(true);
      }
    })();
  }, [navigate, setUser]);

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-brand-red text-white gap-4">
      <div className="animate-pop"><BagLogoTile size={96} /></div>
      <p className="font-display font-bold text-lg">
        {error ? "Greška pri prijavi. Pokušajte ponovo." : "Prijavljivanje…"}
      </p>
      {error && (
        <button onClick={() => navigate("/")} className="underline" data-testid="auth-error-home">
          Nazad na početnu
        </button>
      )}
    </div>
  );
}
